<template>
  <MCheckboxGroup :value="selectedColumns" class="w-full">
    <TransitionGroup name="placeholder">
      <MRow
        v-for="(column, index) in currentColumns"
        :id="column.key"
        :key="column.key"
        class="p-1"
        :class="{
          // 'bg-neutral-lightest': index % 2 === 0,
          'my-2': index !== 0 && index !== currentColumns.length - 1,
        }"
      >
        <MCol>
          <MCheckbox
            :disabled="disabled"
            :value="column.key"
            @change="handleChange($event, column.key)"
          >
            {{ column.text }}
          </MCheckbox>
        </MCol>
      </MRow>
    </TransitionGroup>
  </MCheckboxGroup>
</template>

<script>
import { searchList } from '@utils/arr'
import Uniq from 'lodash/uniq'
export default {
  name: 'ColumnSelectionList',
  model: { event: 'change' },
  props: {
    value: { type: Array, default: undefined },
    columns: { type: Array, required: true },
    query: { type: String, default: undefined },
    disabled: { type: Boolean, default: false },
    collapsibleColumnSelection: { type: Boolean, default: false },
    allColumns: { type: Array, default: undefined },
  },
  computed: {
    currentColumns() {
      if (!this.query || this.collapsibleColumnSelection) {
        return this.columns
      }
      return searchList(this.columns, this.query, 'text')
    },
    columnKeys() {
      if (this.allColumns) {
        return this.allColumns.map(({ key }) => key)
      }
      return this.columns.map(({ key }) => key)
    },
    selectedColumns: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('change', Uniq(v))
      },
    },
  },
  methods: {
    handleChange(isChecked, key) {
      if (isChecked) {
        this.selectedColumns = [...(this.value || []), key]
      } else {
        this.selectedColumns = this.selectedColumns.filter((c) => c !== key)
      }
    },
  },
}
</script>
